/** Import react/libraries section **/
import React from 'react';

/** Import resources section **/
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import logo from '../../assets/espe_logo_blanco.png';
/** Import styles section **/
import './HeaderStyles.scss';
import { APP_NAME } from '../../config/APP_CONFIGS';

/** Import helpers section **/

/** Import component section **/

export const HeaderView = ({ userName, onLogout }) => {
  return (
    <div className="mainheader">
      <div className="mainheader_title">
        <img src={logo} alt="espe-logo" className="mainheader_title_logo" />
        {APP_NAME}
      </div>
      <div className="mainheader_session">
        <PersonIcon className="mainheader_session_usericon" />
        <div className="mainheader_session_profile">
          <div className="mainheader_session_profile_user">{userName}</div>
        </div>
        <div className="mainheader_session_logout">
          <ExitToAppIcon
            className="mainheader_session_logout_icon"
            onClick={onLogout}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderView;
